import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import {
  dialogBodySx,
  dialogShellSx,
  dialogTitleSx,
  getDialogCloseButtonSx,
  getDialogHeaderSx,
  getDialogPaperSx,
} from "components/common/dialogSurfaceStyles";
import { FeedbackForm } from "pages/Feedback";

interface FeedbackDialogProps {
  open: boolean;
  onClose: () => void;
}

function FeedbackDialog({ open, onClose }: FeedbackDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="feedback-dialog-title"
      PaperProps={{
        sx: (theme) => getDialogPaperSx(theme),
      }}
    >
      <Box sx={dialogShellSx}>
        <Box sx={(theme) => getDialogHeaderSx(theme)}>
          <Typography id="feedback-dialog-title" variant="h6" sx={dialogTitleSx}>
            Recon Feedback
          </Typography>
          <IconButton
            aria-label="Close feedback dialog"
            onClick={onClose}
            size="small"
            sx={(theme) => getDialogCloseButtonSx(theme)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <DialogContent sx={dialogBodySx}>
          <FeedbackForm variant="dialog" />
        </DialogContent>
      </Box>
    </Dialog>
  );
}

export default FeedbackDialog;
